import React from 'react';
import { bool, string } from 'prop-types';
import { Container, ContainerLink } from './styles';

const BreadCrumb = ({ title, myAccount }) => (
  <Container>
    <ContainerLink href="/">HOMEPAGE</ContainerLink>
    {myAccount && <ContainerLink href="/user">MY ACCOUNT</ContainerLink>}
    {title.toUpperCase()}
  </Container>
);

BreadCrumb.propTypes = {
  title: string.isRequired,
  myAccount: bool,
};

BreadCrumb.defaultProps = {
  myAccount: false,
};

export default BreadCrumb;
